import { useCallback, useEffect, useMemo, useState } from "react";

import type { Commodity } from "~/shared/schemas/commodity-schema.ts";

export type SelectDescriptor = Record<number, boolean>;

type UseCommoditySelectionProps = {
	data: Commodity[];
	resetOn?: boolean;
};

export function useCommoditySelection({
	data,
	resetOn = false,
}: UseCommoditySelectionProps) {
	const [select, setSelect] = useState<SelectDescriptor>({});
	const [allDataSelected, setAllDataSelected] = useState(false);

	useEffect(() => {
		if (resetOn) {
			setSelect({});
			setAllDataSelected(false);
		}
	}, [resetOn]);

	const selectedItems = useMemo(
		() => data.filter((d) => select[d.id]),
		[select, data],
	);

	const handleCellSelect = useCallback(
		(id: string | number, selected: boolean) => {
			setSelect((prev) => ({ ...prev, [id as number]: selected }));
		},
		[],
	);

	const handleHeaderCellSelect = useCallback(
		(selected: boolean) => {
			const newSelection: SelectDescriptor = {};
			if (selected) {
				for (const item of data) {
					newSelection[item.id] = true;
				}
			}
			setSelect(newSelection);
			setAllDataSelected(selected);
		},
		[data],
	);

	return {
		select,
		allDataSelected,
		selectedItems,
		handleCellSelect,
		handleHeaderCellSelect,
		setAllDataSelected,
	};
}
